var point = '.'

function detectDecimalSeparator(sample) {
    if (!sample) return '.';
    var hasComma = sample.indexOf(',') !== -1;
    var hasDot = sample.indexOf('.') !== -1;
    if (hasComma && hasDot) {
        return sample.lastIndexOf(',') > sample.lastIndexOf('.') ? ',' : '.';
    }
    if (hasComma && !hasDot) return ',';
    return '.';
}

function parseMoneyValue(value) {
    if (!value) return 0;
    var v = value.replace(/[^0-9.,]/g, '');
    var decimals = getCurrencyDecimals(getActiveCurrencyCode());
    if (v.indexOf(',') !== -1 && v.indexOf('.') !== -1) {
        if (v.lastIndexOf(',') > v.lastIndexOf('.')) {
            v = v.replace(/\./g, '').replace(',', '.');
        } else {
            v = v.replace(/,/g, '');
        }
    } else if (v.indexOf(',') !== -1) {
        if (decimals === 0) {
            v = v.replace(/,/g, '');
        } else {
            v = v.replace(',', '.');
        }
    }
    return parseFloat(v) || 0;
}

function getActiveCurrencyCode() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : null;
}

function getCurrencyDecimals(code) {
    if (!code) return 2;
    try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).resolvedOptions().maximumFractionDigits;
    } catch (e) {
        return 2;
    }
}

function formatMoneyNumber(value) {
    var decimals = getCurrencyDecimals(getActiveCurrencyCode());
    try {
        return new Intl.NumberFormat(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value);
    } catch (e) {
        return value.toFixed(decimals).replace('.', point);
    }
}

function formatMoneyWithAffix(value, sample) {
    var text = (sample || '').trim();
    var prefixMatch = text.match(/^[^\d]+/);
    var suffixMatch = text.match(/[^\d]+$/);
    if (prefixMatch || suffixMatch) return (prefixMatch ? prefixMatch[0] : '') + formatMoneyNumber(value) + (suffixMatch ? suffixMatch[0] : '');

    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: getActiveCurrencyCode() || 'GBP'
        }).format(value);
    } catch (e) {
        return '£' + formatMoneyNumber(value);
    }
}

function getMuralMaterialKey(material) {
    var name = (material || '').toLowerCase();
    if (name.indexOf('peel') !== -1) return 'peel-and-stick';
    if (name.indexOf('premium') !== -1 || name.indexOf('luxe') !== -1) return 'premium';
    if (name.indexOf('classic') !== -1 || name.indexOf('standard') !== -1 || name.indexOf('smooth') !== -1) return 'classic';
    return name;
}

function getMuralMinimumProjectVariant(material) {
    var materialKey = getMuralMaterialKey(material);
    var variants = window.WALLPAPER_MURAL_MINIMUM_PROJECT_VARIANTS || [];

    for (var index = 0; index < variants.length; index += 1) {
        if (getMuralMaterialKey(variants[index].title) === materialKey) return variants[index];
    }

    return null;
}

function getSelectedMuralMaterial() {
    var selector = document.querySelector('#mural-material-selector');
    if (selector && selector.value) {
        var option = selector.options[selector.selectedIndex];
        return {
            id: option.getAttribute('data-variant-id'),
            title: option.value,
            price: option.getAttribute('data-price')
        };
    }

    var selectedRadio = document.querySelector('input.c-ptype__radio:checked');
    if (!selectedRadio) return null;
    return {
        id: selectedRadio.value,
        title: selectedRadio.parentElement.querySelector('h3').textContent.trim(),
        price: selectedRadio.parentElement.querySelector('.now').getAttribute('data-per-m2')
    };
}

function showMuralCalculatorMessage(message, focusElement) {
    var messageElement = document.querySelector('#mural-calculator-message');
    if (messageElement) {
        messageElement.textContent = message;
        messageElement.hidden = false;
    }
    if (focusElement) focusElement.focus();
}

function clearMuralCalculatorMessage() {
    var messageElement = document.querySelector('#mural-calculator-message');
    if (messageElement) {
        messageElement.textContent = '';
        messageElement.hidden = true;
    }
}

function setMuralBuilderMeasurementNote(message) {
    var note = document.querySelector('#c-builder-measurement-note');
    if (!note) return;
    note.textContent = message || '';
    note.hidden = !message;
}

function selectMuralMaterial(selector) {
    var selected = selector || document.querySelector('#mural-material-selector');
    if (!selected || !selected.value) return;

    var option = selected.options[selected.selectedIndex];
    var radio = document.querySelector('input.c-ptype__radio[value="' + option.getAttribute('data-variant-id') + '"]');
    if (radio) radio.checked = true;
    updatePrice();
}

function getMuralPricing(material) {
    var selectedMaterial = material || getSelectedMuralMaterial();
    var widthInput = document.querySelector("input[name='properties[Width]']");
    var heightInput = document.querySelector("input[name='properties[Height]']");
    var widthUnit = document.querySelector('#c-width-unit');
    var heightUnit = document.querySelector('#c-height-unit');

    if (!selectedMaterial || !widthInput || !heightInput || !widthUnit || !heightUnit) return null;

    var width = parseFloat(widthInput.value);
    var height = parseFloat(heightInput.value);
    if (!isFinite(width) || !isFinite(height) || width <= 0 || height <= 0) return null;

    var conversion = { cm: 1, in: 2.54, ft: 30.48 };
    var wallArea = (width * conversion[widthUnit.value] * height * conversion[heightUnit.value]) / 10000;
    var quantity = Math.max(1, Math.ceil(wallArea));
    var unitPrice = parseMoneyValue(selectedMaterial.price);
    var minimumVariant = getMuralMinimumProjectVariant(selectedMaterial.title);

    if (!unitPrice) return null;
    if (!minimumVariant || !minimumVariant.id || !minimumVariant.price) {
        return { configurationError: 'The minimum custom wallpaper price is temporarily unavailable. Please contact our team and we will help.' };
    }

    var normalTotalPrice = unitPrice * quantity;
    var minimumProjectPrice = parseMoneyValue(minimumVariant.price);
    if (!minimumProjectPrice) {
        return { configurationError: 'The minimum custom wallpaper price is temporarily unavailable. Please contact our team and we will help.' };
    }

    var minimumApplied = normalTotalPrice < minimumProjectPrice;
    return {
        variantId: minimumApplied ? minimumVariant.id : selectedMaterial.id,
        selectedVariantId: selectedMaterial.id,
        material: selectedMaterial.title,
        quantity: minimumApplied ? 1 : quantity,
        wallArea: wallArea,
        totalPrice: minimumApplied ? minimumProjectPrice : normalTotalPrice,
        normalTotalPrice: normalTotalPrice,
        samplePrice: minimumApplied ? minimumVariant.price : selectedMaterial.price,
        minimumApplied: minimumApplied
    };
}

function updateMuralPricingMessage(pricing) {
    var statuses = document.querySelectorAll('.mural-pricing-status');
    var message = !pricing
        ? 'Choose a material to see your price.'
        : pricing.configurationError
          ? pricing.configurationError
          : pricing.minimumApplied
            ? 'Minimum custom wallpaper price'
            : 'Price based on your wall area.';
    for (var index = 0; index < statuses.length; index += 1) statuses[index].textContent = message;
}

function updateInlineMuralPrice(pricing) {
    var panel = document.querySelector('.mural-inline-price');
    var value = document.querySelector('.mural-inline-price-value');
    if (!panel || !value) return;

    if (!pricing) {
        panel.hidden = true;
        return;
    }

    panel.hidden = false;
    value.textContent = pricing.configurationError ? '' : formatMoneyWithAffix(pricing.totalPrice, pricing.samplePrice);
}

var _moneySample = (document.querySelector("span.now-price") && document.querySelector("span.now-price").getAttribute("data-now-m2")) ||
    (document.querySelector(".c-prices .now") && document.querySelector(".c-prices .now").getAttribute("data-per-m2")) ||
    '';
point = detectDecimalSeparator(_moneySample);
function syncMuralDimensionUnits(changedUnit) {
    var widthUnit = document.querySelector("#c-width-unit"),
        heightUnit = document.querySelector("#c-height-unit");
    if (!widthUnit || !heightUnit) return;

    if (changedUnit === widthUnit) heightUnit.value = widthUnit.value;
    if (changedUnit === heightUnit) widthUnit.value = heightUnit.value;
    updatePrice()
}

function updatePrice(){
    var w = document.querySelector("input[name='properties[Width]']").value, h = document.querySelector("input[name='properties[Height]']").value;
    var w_unit = document.querySelector("#c-width-unit").value, h_unit = document.querySelector("#c-height-unit").value;
    var unit_conversion = {"cm":1,"in":2.54,"ft":30.48}
    if(document.querySelector("span.was-price") != null){
      var was = parseMoneyValue(document.querySelector("span.was-price").attributes['data-was-m2'].value)
    }
    var now = parseMoneyValue(document.querySelector("span.now-price").attributes['data-now-m2'].value);
    var m2 = document.querySelectorAll('.c-price__price .m2')
   

    if(w > 0 && h > 0 && w != '' && h != ''){
      var pricing = getMuralPricing();
      var q = Math.max(1, Math.ceil(w * unit_conversion[w_unit] * h * unit_conversion[h_unit] / 10000));
      if (pricing && !pricing.configurationError) q = pricing.quantity;
      if(typeof was != 'undefined'){
        document.querySelector('.was-price').innerText = formatMoneyNumber(q * was);
        
      }
      document.querySelector('.now-price').innerText = pricing && !pricing.configurationError ? formatMoneyNumber(pricing.totalPrice) : formatMoneyNumber(q * now);
      updateMuralPricingMessage(pricing);
      updateInlineMuralPrice(pricing);
      updateMuralBuilderSummary(pricing);
      for(s=0;s<m2.length;s++){
        m2[s].classList.add('hidden')
      }
      
    } else {
      if(typeof was != 'undefined'){
        document.querySelector('.was-price').innerText = formatMoneyNumber(was);
      }
      document.querySelector('.now-price').innerText = formatMoneyNumber(now);
      updateMuralPricingMessage(null);
      updateInlineMuralPrice(null);
      updateMuralBuilderSummary(null);
      for(s=0;s<m2.length;s++){
        m2[s].classList.remove('hidden')
      }
      
    }
  }

function updateMuralBuilderSummary(pricing) {
    var width = document.querySelector("input[name='properties[Width]']");
    var height = document.querySelector("input[name='properties[Height]']");
    var widthUnit = document.querySelector('#c-width-unit');
    var heightUnit = document.querySelector('#c-height-unit');
    var material = getSelectedMuralMaterial();
    var sizeText = width && height && widthUnit && heightUnit && width.value && height.value
        ? 'W ' + width.value + ' ' + widthUnit.value + ' × H ' + height.value + ' ' + heightUnit.value
        : '';
    var wallCaptionText = width && height && widthUnit && heightUnit && width.value && height.value
        ? 'W ' + width.value + (widthUnit.value === heightUnit.value ? '' : ' ' + widthUnit.value) + ' × H ' + height.value + ' ' + heightUnit.value
        : '';
    var wallSize = document.querySelector('#c-builder-wall-size');
    var wallCaption = document.querySelector('#c-builder-wall-caption');
    var materialText = document.querySelector('#c-builder-material');
    var total = document.querySelector('#c-builder-total');
    var vat = document.querySelector('.c-builder__vat');

    if (wallSize) wallSize.textContent = sizeText;
    if (wallCaption) wallCaption.textContent = wallCaptionText;
    var materialSelector = document.querySelector('#mural-material-selector');
    var selectedOption = materialSelector && materialSelector.selectedOptions[0];
    if (materialText) materialText.textContent = selectedOption ? selectedOption.textContent.trim() : (material ? material.title : '');
    if (total) total.textContent = pricing && !pricing.configurationError
        ? formatMoneyWithAffix(pricing.totalPrice, pricing.samplePrice)
        : '';
    if (vat) vat.hidden = getActiveCurrencyCode() !== 'GBP';
}
var trim = 6,
    gutters = 88 * window.devicePixelRatio,
    unit_conversion = {
        cm: 1,
        in: 2.54,
        ft: 30.48
    },
    canvas = document.getElementById("c-canvas"),
    ctx = canvas.getContext("2d"),
    hiddencanvas = document.querySelector("#c-canvas-image"),
    h_ctx = hiddencanvas.getContext("2d"),
    available_x, available_y, preview_width, preview_height, preview_aspect, loaded_width, pattern_width = "unset",
    border_shade = "unset",
    final_width_cm, final_height_cm, user_width, user_width_units, user_height, user_height_units, img = new Image,
    img_width_cm, img_height_cm, dx, dx_cm, fdx, lim_x, dy, dy_cm, lim_y, ppcm, wallpaper = new Image,
    coords = {},
    Sx, Sy, Sw, Sh, Fx, Fh, Fw, Fh, C, clientX, clientY, dx0, dy0, dragging = "unset",
    top_cm, left_cm, out = document.querySelector("#c-canvas-output"),
    out_w = 1e3,
    flipX = 1,
    monoX = !1,
    rulerVisible = !1,
    Uparams = new URLSearchParams,
    proofurl;

function setCanvasSize() {
    var mobilePreview = window.matchMedia('(max-width: 749px)').matches;
    gutters = (mobilePreview ? 28 : 88) * window.devicePixelRatio;
    canvas.style.height = mobilePreview
        ? ((canvas.clientWidth - 56) / (final_width_cm / final_height_cm) + 56) + 'px'
        : '';
    (canvas.width !== canvas.clientWidth * window.devicePixelRatio || canvas.height !== canvas.clientHeight * window.devicePixelRatio) && (canvas.width = canvas.clientWidth * window.devicePixelRatio, canvas.height = canvas.clientHeight * window.devicePixelRatio), available_x = canvas.width - 2 * gutters, available_y = canvas.height - 2 * gutters, preview_aspect = final_width_cm / final_height_cm, preview_aspect >= 1.4 ? (preview_width = available_x, preview_height = available_x / preview_aspect) : (preview_height = available_y, preview_width = available_y * preview_aspect), coords = {
            xi: [(canvas.width - preview_width) / 2, (canvas.width + preview_width) / 2, (canvas.width + preview_width) / 2, (canvas.width - preview_width) / 2],
            xf: [(canvas.width - preview_width) / 2 - gutters, (canvas.width + preview_width) / 2 + gutters, (canvas.width + preview_width) / 2 + gutters, (canvas.width - preview_width) / 2 - gutters],
            yi: [(canvas.height - preview_height) / 2, (canvas.height - preview_height) / 2, (canvas.height + preview_height) / 2, (canvas.height + preview_height) / 2],
            yf: [(canvas.height - preview_height) / 2 - .5 * gutters, (canvas.height - preview_height) / 2 - .5 * gutters, (canvas.height + preview_height) / 2 + .5 * gutters, (canvas.height + preview_height) / 2 + .5 * gutters]
        }, amount = .3, fade_line = [new Path2D, new Path2D, new Path2D, new Path2D], fd_grd = [ctx.createLinearGradient(0, 0, gutters * amount, 0), ctx.createLinearGradient(canvas.width - gutters * amount, 0, canvas.width, 0), ctx.createLinearGradient(0, 0, 0, gutters * .2), ctx.createLinearGradient(0, canvas.height, 0, canvas.height - gutters * .2)], fd_grd[0].addColorStop(0, "rgba(255, 255, 255,1)"), fd_grd[0].addColorStop(1, "rgba(255, 255, 255,0)"), fd_grd[1].addColorStop(1, "rgba(255, 255, 255,1)"), fd_grd[1].addColorStop(0, "rgba(255, 255, 255,0)"), fd_grd[2].addColorStop(0, "rgba(255, 255, 255,1)"), fd_grd[2].addColorStop(1, "rgba(255, 255, 255,0)"), fd_grd[3].addColorStop(0, "rgba(255, 255, 255,1)"), fd_grd[3].addColorStop(1, "rgba(255, 255, 255,0)");
    reportValues()
}



function setImage(is_mono) {
    typeof document.querySelector(".product__media-item>img.artwork").attributes["data-pattern-width"] != "undefined" && pattern_width == "unset" && (pattern_width = document.querySelector(".product__media-item>img.artwork").attributes["data-pattern-width"].value), typeof document.querySelector(".product__media-item>img.artwork").attributes["data-border-shade"] != "undefined" && border_shade == "unset" && (border_shade = document.querySelector(".product__media-item>img.artwork").attributes["data-border-shade"].value), img.onload = function() {
        if (wallpaper_aspect = img.width / img.height, pattern_width !== "unset" && pattern_width !== "Fill")
            if (pattern_width == "Pano")
                for (rep_x = Math.ceil(.5 + final_width_cm / (final_height_cm * wallpaper_aspect)), rep_y = 1, img_height_cm = final_height_cm, img_width_cm = final_height_cm * wallpaper_aspect * rep_x, rep_x * img.width > rep_y * img.height ? (hiddencanvas.width = 4e3, hiddencanvas.height = hiddencanvas.width / rep_x / wallpaper_aspect) : (hiddencanvas.height = 4e3, hiddencanvas.width = hiddencanvas.height * wallpaper_aspect), C = preview_width / (final_width_cm * hiddencanvas.width / img_width_cm), loaded_width = preview_width, x = 0; x < rep_x; x++) h_ctx.drawImage(img, 0, 0, img.width, img.height, x * hiddencanvas.width / rep_x, 0, hiddencanvas.width / rep_x, hiddencanvas.height);
            else if (pattern_width == "Fit") wallpaper_aspect >= preview_aspect ? (img_width_cm = final_width_cm - 6, img_height_cm = img_width_cm / wallpaper_aspect, hiddencanvas.width = img.width, hiddencanvas.height = img.height, h_ctx.drawImage(img, 0, 0), C = img_width_cm * preview_width / final_width_cm / img.width) : (img_height_cm = final_height_cm - trim, img_width_cm = img_height_cm * wallpaper_aspect, hiddencanvas.width = img.width, hiddencanvas.height = img.height, h_ctx.drawImage(img, 0, 0), C = img_height_cm * preview_height / final_height_cm / img.height);
        else
            for (rep_x = Math.ceil(.5 + final_width_cm / pattern_width), rep_y = Math.ceil(.5 + final_height_cm / (pattern_width / wallpaper_aspect)), img_width_cm = pattern_width * rep_x, img_height_cm = pattern_width / wallpaper_aspect * rep_y, rep_x * img.width > rep_y * img.height ? (hiddencanvas.width = 4e3, hiddencanvas.height = rep_y * (hiddencanvas.width / rep_x) / wallpaper_aspect) : (hiddencanvas.height = 4e3, hiddencanvas.width = rep_x * (hiddencanvas.height / rep_y) * wallpaper_aspect), C = preview_width / (final_width_cm * hiddencanvas.width / img_width_cm), loaded_width = preview_width, x = 0; x < rep_x; x++)
                for (y = 0; y < rep_y; y++) h_ctx.drawImage(img, 0, 0, img.width, img.height, x * hiddencanvas.width / rep_x, y * hiddencanvas.height / rep_y, hiddencanvas.width / rep_x, hiddencanvas.height / rep_y);
        else if (wallpaper_aspect >= preview_aspect) img_height_cm = final_height_cm, img_width_cm = img_height_cm * wallpaper_aspect, hiddencanvas.width = img.width, hiddencanvas.height = img.height, h_ctx.drawImage(img, 0, 0), C = preview_height / img.height;
        else if (wallpaper_aspect < preview_aspect) img_width_cm = final_width_cm, img_height_cm = img_width_cm / wallpaper_aspect, hiddencanvas.width = img.width, hiddencanvas.height = img.height, h_ctx.drawImage(img, 0, 0), C = preview_width / img.width;
        else return;
        if (is_mono == "mono") {
            for (var imageData = h_ctx.getImageData(0, 0, hiddencanvas.width, hiddencanvas.height), dataArray = imageData.data, d = 0; d < dataArray.length; d += 4) {
                var grey = Math.round(.2126 * dataArray[d] + .7152 * dataArray[d + 1] + .0722 * dataArray[d + 2]);
                dataArray[d] = grey, dataArray[d + 1] = grey, dataArray[d + 2] = grey
            }
            imageData.data = dataArray, h_ctx.putImageData(imageData, 0, 0)
        }
        ppcm = preview_width / final_width_cm, is_mono == "mono" || is_mono == "false" || (pattern_width == "Fit" ? wallpaper_aspect >= preview_aspect ? (dx = -(trim / 2) * ppcm, lim_x = 0, dx_cm = -(trim / 2), dy = (img_height_cm * ppcm - preview_height) / 2, lim_y = -(img_height_cm * ppcm - preview_height + ppcm * trim / 2), dy_cm = (img_height_cm * ppcm - preview_height) / (2 * ppcm)) : (dy = -3 * ppcm, dy_cm = -3, lim_y = 0, dx = (img_width_cm * ppcm - preview_width) / 2, lim_x = -(img_width_cm * ppcm - preview_width + ppcm * (trim / 2)), dx_cm = (img_width_cm * ppcm - preview_width) / (2 * ppcm)) : (dx = (img_width_cm * ppcm - preview_width) / 2, lim_x = img_width_cm * ppcm - preview_width, dx_cm = (img_width_cm * ppcm - preview_width) / (2 * ppcm), dy = (img_height_cm * ppcm - preview_height) / 2, lim_y = img_height_cm * ppcm - preview_height, dy_cm = (img_height_cm * ppcm - preview_height) / (2 * ppcm))), draw(), reportValues()
    }, img.crossOrigin = "Anonymous", img.src = document.querySelector(".product__media-item>img.artwork").src
}

function draw() {
    ctx.clearRect(0, 0, canvas.width * window.devicePixelRatio, canvas.height), (Math.abs(canvas.width - canvas.clientWidth * window.devicePixelRatio) > 1 || Math.abs(canvas.height - canvas.clientHeight * window.devicePixelRatio > 1)) && setCanvasSize(), canvas.width > 0 && (flipX == -1 ? (pattern_width == "Fit" && drawBG(), ctx.save(), ctx.scale(flipX, 1), pattern_width !== "Fit" && drawFull(), drawCrop(), ctx.restore()) : (pattern_width == "Fit" ? drawBG() : drawFull(), drawCrop()), drawRoom(), drawFade(), rulerVisible && drawRuler(), drawInfo(), updateOutput())
}

function toggleRuler(button) {
    rulerVisible = !rulerVisible;
    button.setAttribute("aria-pressed", rulerVisible ? "true" : "false");
    button.querySelector("span:last-child").textContent = rulerVisible ? "Hide ruler" : "Show ruler";
    draw()
}

function initialiseDragging() {
    canvas.addEventListener("touchstart", function(e) {
        return e.preventDefault(), !1
    }, {
        passive: !1
    }), canvas.addEventListener("touchmove", function(e) {
        return e.preventDefault(), !1
    }, {
        passive: !1
    }), canvas.addEventListener("touchend", function(e) {
        return e.preventDefault(), !1
    }, {
        passive: !1
    }), canvas.addEventListener("touchforcechange", function(e) {
        return e.preventDefault(), !1
    }, {
        passive: !1
    }), canvas.addEventListener("pointerdown", function(e) {
        e.preventDefault(), dx0 = dx, dy0 = dy, clientX = e.x, clientY = e.y, dragging = !0
    }, {
        passive: !1
    }), canvas.addEventListener("pointermove", function(e) {
        return e.preventDefault(), dragging == !0 && (e.preventDefault(), usr_dx = dx0 - window.devicePixelRatio * (e.x - clientX), usr_dy = dy0 - window.devicePixelRatio * (e.y - clientY), flipX == 1 ? (usr_dx >= 0 && usr_dx <= lim_x ? dx = usr_dx : usr_dx < 0 ? dx = 0 : usr_dx > lim_x && (dx = lim_x), pattern_width == "Fit" && (lim_x == 0 ? dx = -(trim / 2) * ppcm : usr_dx <= -(trim / 2) * ppcm && usr_dx >= -lim_x ? dx = usr_dx : usr_dx > -(trim / 2) * ppcm ? dx = -(trim / 2) * ppcm : usr_dx < -lim_x && (dx = -lim_x))) : (usr_dx >= 0 && usr_dx <= lim_x ? (dx = usr_dx, fdx = hiddencanvas.width * C - usr_dx - preview_width) : usr_dx < 0 ? (dx = 0, fdx = hiddencanvas.width * C - preview_width) : usr_dx < lim_x && (dx = lim_x, fdx = hiddencanvas.width * C - lim_x - preview_width), pattern_width == "Fit" && (lim_x == 0 ? dx = -(trim / 2) * ppcm : usr_dx <= -(trim / 2) * ppcm && usr_dx >= -lim_x ? (dx = usr_dx, fdx = hiddencanvas.width * C - usr_dx - preview_width) : usr_dx > -(trim / 2) * ppcm ? (dx = -(trim / 2) * ppcm, fdx = hiddencanvas.width * C - preview_width + trim / 2 * ppcm) : usr_dx < -lim_x && (dx = -lim_x, fdx = hiddencanvas.width * C + lim_x - preview_width))), usr_dy >= 0 && usr_dy <= lim_y ? dy = usr_dy : usr_dy < 0 ? dy = 0 : usr_dy > lim_y && (dy = lim_y), pattern_width == "Fit" && (lim_y == 0 ? dy = -(trim / 2) * ppcm : usr_dy <= -(trim / 2) * ppcm && usr_dy >= -lim_y ? dy = usr_dy : usr_dy > -(trim / 2) * ppcm ? dy = -(trim / 2) * ppcm : usr_dy < -lim_y && (dy = -lim_y)), draw()), !1
    }, {
        passive: !1
    }), canvas.addEventListener("pointerup", function(e) {
        e.preventDefault(), dragging == !0 && (dragging = !1, draw(), reportValues())
    }, {
        passive: !1
    }), canvas.addEventListener("pointercancel", function(e) {
        e.preventDefault(), dragging == !0 && (dragging = !1, draw(), reportValues())
    }, {
        passive: !1
    }), canvas.addEventListener("pointerleave", function(e) {
        e.preventDefault(), dragging == !0 && (dragging = !1, draw(), reportValues())
    }, {
        passive: !1
    }), canvas.addEventListener("touchmove", this.preventDefault, {
        passive: !1
    }), canvas.addEventListener("touchforcechange", this.preventDefault, {
        passive: !1
    })
}

function hideBuilder() {
    document.querySelector(".c-modal__bg").classList.add("hide")
}

function reportValues() {
    form = document.querySelector("form.product-form"), form.querySelector('input[name="quantity"]').value = Math.max(Math.ceil(user_width * unit_conversion[user_width_units] * (user_height * unit_conversion[user_height_units]) / 1e4), 1), urlParams((dy / ppcm).toFixed(5), (dx / ppcm).toFixed(5))
}

function openBuilder(edit) {
    selectMuralMaterial();
    if (!getSelectedMuralMaterial()) {
        showMuralCalculatorMessage('Choose your wallpaper material before previewing your crop.', document.querySelector('#mural-material-selector'));
        return;
    }
    var userv_width = document.querySelector('input[name="properties[Width]"]').value;
    var userv_height = document.querySelector('input[name="properties[Height]"]').value;
    var userv_width_unit = document.querySelector('#c-width-unit').value;
    var userv_height_unit = document.querySelector('#c-height-unit').value;

    /*if(( userv_width <= 199 && userv_width_unit == "cm") || (userv_height <= 199 && userv_height_unit == "cm")){
      $(".validation_error").show(); 
        setTimeout(function() {
            $('.validation_error').fadeOut('fast');
        }, 5000);
    }
   else if(( userv_width <= 78.7402 && userv_width_unit == "in") || (userv_height <= 78.7402 && userv_height_unit == "in")){
      $(".validation_error").show(); 
        setTimeout(function() {
            $('.validation_error').fadeOut('fast');
        }, 5000);
    } 
    else if((userv_width_unit == "cm" && userv_height_unit == "in") || (userv_width_unit == "in" && userv_height_unit == "cm")){
      $(".validation_error").show(); 
        setTimeout(function() {
            $('.validation_error').fadeOut('fast');
        }, 5000);
    } */
    if (updatePrice(), user_width = document.querySelector('input[name="properties[Width]"]').value, user_width_units = document.querySelector('select[name="properties[Width Units]"]').value, user_height = document.querySelector('input[name="properties[Height]"]').value, user_height_units = document.querySelector('select[name="properties[Height Units]"]').value, isNaN(user_width) || isNaN(user_height)) {
        showMuralCalculatorMessage('Enter numbers for both wall measurements, then preview your crop.', document.querySelector('.c-dims-input__input'));
        return
    }
    if (!(user_width > 0 && user_height > 0)) {
        showMuralCalculatorMessage('Please enter your wall width & height.', document.querySelector('.c-dims-input__input')), setTimeout(function() {
            document.querySelectorAll(".c-dims-input")[0].classList.add("error"), document.querySelectorAll(".c-dims-input")[1].classList.add("error")
        }, 200), setTimeout(function() {
            document.querySelectorAll(".c-dims-input")[0].classList.remove("error"), document.querySelectorAll(".c-dims-input")[1].classList.remove("error")
        }, 400), setTimeout(function() {
            document.querySelectorAll(".c-dims-input")[0].classList.add("error"), document.querySelectorAll(".c-dims-input")[1].classList.add("error")
        }, 600), setTimeout(function() {
            document.querySelectorAll(".c-dims-input")[0].classList.remove("error"), document.querySelectorAll(".c-dims-input")[1].classList.remove("error")
        }, 800);
        return
    }
    clearMuralCalculatorMessage();
    document.querySelector(".c-builder__details .error-small").classList.add("hidden");
    document.querySelector(".c-builder__details .error-large").classList.add("hidden");
    document.querySelector(".c-builder__details .error-units").classList.add("hidden");
    material_change();

    var enteredWidthCm = user_width * unit_conversion[user_width_units],
        enteredHeightCm = user_height * unit_conversion[user_height_units];
    if (enteredWidthCm < 30 || enteredHeightCm < 30) {
        setMuralBuilderMeasurementNote('Please check your wall measurements and selected unit. You can still continue — our minimum wallpaper price applies.');
    } else if (enteredWidthCm > 1800 || enteredHeightCm > 650) {
        setMuralBuilderMeasurementNote('This is an unusually large wall. Please check your measurements before continuing.');
    } else {
        setMuralBuilderMeasurementNote('');
    }

    dragging == "unset" && initialiseDragging();
    var submitButton = document.querySelector(".c-submit"),
        customiseButton = document.querySelector(".c-builder__customise-button"),
        buttonContainer = document.querySelector(".c-button-cont");
    if (edit == "Edit") {
        submitButton.classList.remove("button--primary");
        submitButton.classList.add("button--secondary");
        if (customiseButton) {
            customiseButton.classList.add("button--primary");
            customiseButton.classList.remove("button--secondary");
        }
        buttonContainer.classList.add("proof");
    } else {
        submitButton.classList.add("button--primary");
        submitButton.classList.remove("button--secondary");
        if (customiseButton) {
            customiseButton.classList.remove("button--primary");
            customiseButton.classList.add("button--secondary");
        }
        buttonContainer.classList.remove("proof");
    }
    var prices = document.querySelectorAll(".c-prices .now");
    for (p = 0; p < prices.length; p++) {
        var priceElement = prices[p];
        var optionButton = priceElement.closest('.c-ptype__button');
        var optionRadio = optionButton.querySelector('input.c-ptype__radio');
        var optionPricing = getMuralPricing({
            id: optionRadio.value,
            title: optionButton.querySelector('h3').textContent.trim(),
            price: priceElement.getAttribute('data-per-m2')
        });
        priceElement.innerText = optionPricing && !optionPricing.configurationError
            ? formatMoneyNumber(optionPricing.totalPrice)
            : formatMoneyNumber(parseMoneyValue(priceElement.getAttribute('data-per-m2')) * Math.max(1, Math.ceil(user_width * unit_conversion[user_width_units] * (user_height * unit_conversion[user_height_units]) / 1e4)));
    }
    document.querySelector(".c-modal__bg").classList.remove("hide"), final_width_cm = user_width * unit_conversion[user_width_units] + trim, final_height_cm = user_height * unit_conversion[user_height_units] + trim, window.onresize = function() {
        setCanvasSize(), draw()
    }, typeof screen.orientation == "undefined" ? window.addEventListener("resize", function() {
        setCanvasSize(), draw()
    }) : screen.orientation.addEventListener("change", function() {
        setCanvasSize(), draw()
    }), setCanvasSize(), setImage(monoX), img.complete || (ctx.textAlign = "center", ctx.font = 20 * window.devicePixelRatio + "px sans-serif", ctx.fillText(loading_text, canvas.width / 2, canvas.height / 2, canvas.width)), loaded_width !== preview_width && (setImage(monoX), draw()), draw(), reportValues()
}
var clone_of_inputpw = null,
    inputpw, parent_of_inputpw, clone_of_inputbs = null,
    inputbs, parent_of_inputbs;

function fit(fill) {
    var fbutton = document.querySelector("button[onclick=\"fit('fill')\"]") || document.querySelector("button[onclick=\"fit('fit')\"]");
    clone_of_inputpw == null && (inputpw = document.querySelector('input[name="properties[_Pattern Width]"]'), clone_of_inputpw = inputpw.cloneNode(!0), parent_of_inputpw = inputpw.parentElement, inputbs = document.querySelector('input[name="properties[_Border Shade]"]'), clone_of_inputbs = inputbs.cloneNode(!0), parent_of_inputbs = inputbs.parentElement), fill == "fill" ? (pattern_width = "Fill", setImage(monoX), fbutton.innerText = fbutton.attributes["data-fit-text"].value, fbutton.attributes.onclick.value = "fit('fit')", inputpw = document.querySelector('input[name="properties[_Pattern Width]"]'), inputbs = document.querySelector('input[name="properties[_Border Shade]"]'), parent_of_inputpw.removeChild(inputpw), parent_of_inputbs.removeChild(inputbs)) : (pattern_width = "Fit", setImage(monoX), fbutton.innerText = fbutton.attributes["data-fill-text"].value, fbutton.attributes.onclick.value = "fit('fill')", parent_of_inputpw.appendChild(clone_of_inputpw), parent_of_inputbs.appendChild(clone_of_inputbs))
}

function updateOutput() {
    out.width = out_w, out.height = out_w * final_height_cm / final_width_cm, pattern_width == "Fit" ? (out.getContext("2d").fillStyle = border_shade, out.getContext("2d").fillRect(0, 0, out.width, out.height), flipX == 1 ? out.getContext("2d").drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, -dx / ppcm * (out_w / final_width_cm), -dy / ppcm * (out_w / final_width_cm), hiddencanvas.width * (out_w * C / preview_width), hiddencanvas.height * (out_w * C / preview_width)) : (out.getContext("2d").save(), out.getContext("2d").scale(flipX, 1), out.getContext("2d").drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, -out_w + -fdx / ppcm * (out_w / final_width_cm), -dy / ppcm * (out_w / final_width_cm), hiddencanvas.width * (out_w * C / preview_width), hiddencanvas.height * (out_w * C / preview_width)), out.getContext("2d").restore())) : flipX == 1 ? out.getContext("2d").drawImage(hiddencanvas, dx / C, dy / C, Sw, Sh, 0, 0, Sw * (out_w * C / preview_width), Sh * (out_w * C / preview_width)) : (out.getContext("2d").save(), out.getContext("2d").scale(flipX, 1), out.getContext("2d").drawImage(hiddencanvas, fdx / C, dy / C, Sw, Sh, -out_w, 0, Sw * (out_w * C / preview_width), Sh * (out_w * C / preview_width)), out.getContext("2d").restore())
}
var grd = [];

function drawFull() {
    dragging == !0 ? ctx.globalAlpha = .5 : ctx.globalAlpha = .15, flipX == 1 ? ctx.drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, coords.xi[0] - dx, (canvas.height - preview_height) / 2 - dy, hiddencanvas.width * C, hiddencanvas.height * C) : ctx.drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, -preview_width - coords.xi[0] - fdx, (canvas.height - preview_height) / 2 - dy, hiddencanvas.width * C, hiddencanvas.height * C), ctx.globalAlpha = 1
}

function drawBG() {
    if (monoX == !0) {
        var rgb = hexToRgb(border_shade),
            border_shade_mono = Math.round(.2126 * rgb.r + .7152 * rgb.g + .0722 * rgb.b);
        ctx.fillStyle = rgbToHex(border_shade_mono, border_shade_mono, border_shade_mono)
    } else ctx.fillStyle = border_shade;
    ctx.fillRect(coords.xi[0], coords.yi[0], preview_width, preview_height), ctx.fillStyle = "#000000"
}

function drawCrop() {
    Sw = preview_width / C, Sh = preview_height / C, pattern_width == "Fit" ? flipX == 1 ? ctx.drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, coords.xi[0] - dx, (canvas.height - preview_height) / 2 - dy, hiddencanvas.width * C, hiddencanvas.height * C) : ctx.drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, -preview_width - coords.xi[0] - fdx, (canvas.height - preview_height) / 2 - dy, hiddencanvas.width * C, hiddencanvas.height * C) : flipX == 1 ? ctx.drawImage(hiddencanvas, dx / C, dy / C, Sw, Sh, coords.xi[0], coords.yi[0], Sw * C, Sh * C) : ctx.drawImage(hiddencanvas, fdx / C, dy / C, Sw, Sh, -preview_width - coords.xi[0], coords.yi[0], Sw * C, Sh * C)
}

function drawInfo() {
    var scale = window.devicePixelRatio,
        lineColour = "rgba(45, 44, 39, 0.52)",
        arrowSize = 6 * scale,
        bottomY = coords.yi[3] + gutters * .55,
        rightX = coords.xi[1] + gutters * .55,
        widthLabel = user_width + " " + user_width_units,
        heightLabel = user_height + " " + user_height_units;

    ctx.save();
    ctx.strokeStyle = lineColour;
    ctx.fillStyle = "#2d2c27";
    ctx.lineWidth = 1 * scale;
    ctx.font = 12 * scale + "px sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    // Width dimension line with inward-facing arrowheads.
    ctx.beginPath();
    ctx.moveTo(coords.xi[0], bottomY);
    ctx.lineTo(coords.xi[1], bottomY);
    ctx.moveTo(coords.xi[0], bottomY);
    ctx.lineTo(coords.xi[0] + arrowSize, bottomY - arrowSize * .65);
    ctx.moveTo(coords.xi[0], bottomY);
    ctx.lineTo(coords.xi[0] + arrowSize, bottomY + arrowSize * .65);
    ctx.moveTo(coords.xi[1], bottomY);
    ctx.lineTo(coords.xi[1] - arrowSize, bottomY - arrowSize * .65);
    ctx.moveTo(coords.xi[1], bottomY);
    ctx.lineTo(coords.xi[1] - arrowSize, bottomY + arrowSize * .65);
    ctx.stroke();

    var widthLabelWidth = ctx.measureText(widthLabel).width + 16 * scale;
    ctx.fillStyle = "#fff";
    ctx.fillRect(canvas.width / 2 - widthLabelWidth / 2, bottomY - 10 * scale, widthLabelWidth, 20 * scale);
    ctx.fillStyle = "#2d2c27";
    ctx.fillText(widthLabel, canvas.width / 2, bottomY);

    // Height dimension line with inward-facing arrowheads on the right.
    ctx.strokeStyle = lineColour;
    ctx.beginPath();
    ctx.moveTo(rightX, coords.yi[0]);
    ctx.lineTo(rightX, coords.yi[3]);
    ctx.moveTo(rightX, coords.yi[0]);
    ctx.lineTo(rightX - arrowSize * .65, coords.yi[0] + arrowSize);
    ctx.moveTo(rightX, coords.yi[0]);
    ctx.lineTo(rightX + arrowSize * .65, coords.yi[0] + arrowSize);
    ctx.moveTo(rightX, coords.yi[3]);
    ctx.lineTo(rightX - arrowSize * .65, coords.yi[3] - arrowSize);
    ctx.moveTo(rightX, coords.yi[3]);
    ctx.lineTo(rightX + arrowSize * .65, coords.yi[3] - arrowSize);
    ctx.stroke();

    ctx.save();
    ctx.translate(rightX, canvas.height / 2);
    ctx.rotate(-Math.PI / 2);
    var heightLabelWidth = ctx.measureText(heightLabel).width + 16 * scale;
    ctx.fillStyle = "#fff";
    ctx.fillRect(-heightLabelWidth / 2, -10 * scale, heightLabelWidth, 20 * scale);
    ctx.fillStyle = "#2d2c27";
    ctx.fillText(heightLabel, 0, 0);
    ctx.restore();
    ctx.restore()
}

function drawRuler() {
    var scale = window.devicePixelRatio,
        width = Number(user_width) || Number(final_width_cm),
        height = Number(user_height) || Number(final_height_cm),
        widthUnit = user_width_units || "cm",
        heightUnit = user_height_units || "cm";
    if (!width || !height) return;

    var majorStep = 50,
        minorStep = 50,
        topY = coords.yi[0] - 13 * scale,
        leftX = coords.xi[0] - 13 * scale,
        tickLength = 7 * scale;

    ctx.save();
    ctx.strokeStyle = "rgba(45, 44, 39, 0.72)";
    ctx.fillStyle = "rgba(45, 44, 39, 0.82)";
    ctx.lineWidth = 1 * scale;
    ctx.font = 10 * scale + "px sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";

    var mobileRuler = window.matchMedia('(max-width: 749px)').matches;
    if (mobileRuler) {
        majorStep = Math.max(50, Math.ceil(Math.max(width / (preview_width / (60 * scale)), height / (preview_height / (60 * scale))) / 50) * 50);
    }

    ctx.beginPath();
    ctx.moveTo(coords.xi[0], topY);
    ctx.lineTo(coords.xi[1], topY);
    ctx.moveTo(leftX, coords.yi[0]);
    ctx.lineTo(leftX, coords.yi[3]);

    for (var x = 0; x <= width; x += minorStep) {
        var xPosition = coords.xi[0] + x / width * preview_width,
            xIsMajor = Math.abs(x % majorStep) < .001 || Math.abs(x - width) < minorStep / 2;
        ctx.moveTo(xPosition, topY);
        ctx.lineTo(xPosition, topY + (xIsMajor ? tickLength : tickLength * .55));
    }
    for (var y = 0; y <= height; y += minorStep) {
        var yPosition = coords.yi[0] + y / height * preview_height,
            yIsMajor = Math.abs(y % majorStep) < .001 || Math.abs(y - height) < minorStep / 2;
        ctx.moveTo(leftX, yPosition);
        ctx.lineTo(leftX + (yIsMajor ? tickLength : tickLength * .55), yPosition);
    }
    ctx.stroke();

    for (var labelX = 0; labelX <= width; labelX += majorStep) {
        if (mobileRuler && labelX > 0 && labelX < width && width - labelX < majorStep * .6) continue;
        var shownX = Math.min(labelX, width),
            labelXPosition = coords.xi[0] + shownX / width * preview_width;
        ctx.fillText(shownX === 0 ? "0" : shownX + " " + widthUnit, labelXPosition, topY - 3 * scale);
    }
    if (width % majorStep) ctx.fillText(width + " " + widthUnit, coords.xi[1], topY - 3 * scale);

    ctx.save();
    ctx.textAlign = "right";
    ctx.textBaseline = "middle";
    for (var labelY = 0; labelY <= height; labelY += majorStep) {
        if (mobileRuler && labelY > 0 && labelY < height && height - labelY < majorStep * .6) continue;
        var shownY = Math.min(labelY, height),
            labelYPosition = coords.yi[0] + shownY / height * preview_height;
        if (mobileRuler) {
            ctx.save();
            ctx.translate(leftX - 5 * scale, labelYPosition);
            ctx.rotate(-Math.PI / 2);
            ctx.textAlign = "center";
            ctx.fillText(shownY === 0 ? "0" : shownY + " " + heightUnit, 0, 0);
            ctx.restore();
        } else {
            ctx.fillText(shownY === 0 ? "0" : shownY + " " + heightUnit, leftX - 5 * scale, labelYPosition);
        }
    }
    if (height % majorStep) {
        if (mobileRuler) {
            ctx.translate(leftX - 5 * scale, coords.yi[3]);
            ctx.rotate(-Math.PI / 2);
            ctx.textAlign = "center";
            ctx.fillText(height + " " + heightUnit, 0, 0);
        } else {
            ctx.fillText(height + " " + heightUnit, leftX - 5 * scale, coords.yi[3]);
        }
    }
    ctx.restore();
    ctx.restore()
}
var fade_line, fd_grd, amount;

function drawFade() {
    ctx.fillStyle = fd_grd[0], fade_line[0].rect(0, 0, gutters * amount, canvas.height), ctx.fill(fade_line[0]), ctx.fillStyle = fd_grd[1], fade_line[1].rect(canvas.width - gutters * amount, 0, gutters * amount, canvas.height), ctx.fill(fade_line[1]), ctx.fillStyle = fd_grd[2], fade_line[2].rect(0, 0, canvas.width, gutters * .2), ctx.fill(fade_line[2]), ctx.fillStyle = fd_grd[3], fade_line[3].rect(0, canvas.height - gutters * .2, canvas.width, gutters * .2), ctx.fill(fade_line[3])
}

function drawRoom() {
    for (ctx.beginPath(), ctx.rect(coords.xi[0], coords.yi[0], preview_width, preview_height), ctx.stroke(), ctx.closePath(), i = 0; i < coords.xi.length; i++) {
        var room_line = new Path2D;
        grd[i] = ctx.createLinearGradient(coords.xf[i], coords.yf[i], coords.xi[i], coords.yi[i]), grd[i].addColorStop(1, "black"), grd[i].addColorStop(.3, "transparent"), ctx.strokeStyle = grd[i], room_line.moveTo(coords.xf[i], coords.yf[i]), room_line.lineTo(coords.xi[i], coords.yi[i]), room_line.closePath(), ctx.stroke(room_line)
    }
}

function endgame() {
    if (!document.querySelector('input.c-ptype__radio:checked')) {
        alert("Please select a paper type to continue!"), setTimeout(function() {
            document.querySelector(".c-ptype-cont").classList.add("error")
        }, 200), setTimeout(function() {
            document.querySelector(".c-ptype-cont").classList.remove("error")
        }, 400), setTimeout(function() {
            document.querySelector(".c-ptype-cont").classList.add("error")
        }, 600), setTimeout(function() {
            document.querySelector(".c-ptype-cont").classList.remove("error")
        }, 800);
        return
    }
    reportValues();
    var muralPricing = getMuralPricing();
    if (!muralPricing || muralPricing.configurationError) {
        alert(muralPricing && muralPricing.configurationError ? muralPricing.configurationError : 'Please enter your wall width and height to continue.');
        return;
    }
    
    var submitButton = document.querySelector(".c-submit"),
        submitButtonText = submitButton.querySelector("span").innerText,
        cartDrawer = document.querySelector("cart-drawer");
    var userv_width = document.querySelector('input[name="properties[Width]"]').value;
    var userv_height = document.querySelector('input[name="properties[Height]"]').value;
    var userv_width_unit = document.querySelector('#c-width-unit').value;
    var userv_height_unit = document.querySelector('#c-height-unit').value;
    var wallSize = "W " + userv_width + userv_width_unit + " x H " + userv_height + userv_height_unit;
    submitButton.setAttribute("aria-disabled", !0), submitButton.querySelector("span").innerText = upload_text;
    var shopifyAjaxAddURL = "/cart/add.js",
        shopifyAjaxStorePageURL = "/search",
        out2 = document.querySelector("#c-canvas-output"),
        formData = new FormData(document.querySelector("product-form.c-builder__form > form")),
        datau = out2.toDataURL();
        formData.set('id', muralPricing.variantId);
        formData.set('quantity', muralPricing.quantity);
        formData.delete("properties[Width]");
        formData.delete("properties[Height]");
        formData.delete("properties[Width Units]");
        formData.delete("properties[Height Units]");
        formData.set("properties[Wall size]", wallSize);
        formData.set("properties[_Wall area]", muralPricing.wallArea.toFixed(2) + " m²");
    try {
        var blob = createBlob(datau);
        upload_file = new File([blob], "img.png", {
            type: "image/png",
            lastModified: new Date().getTime()
        })
    } catch (e) {}
    typeof upload_file != "undefined" && formData.append("properties[Design preview]", upload_file, "image.png");
    try {
        var preorder = document.querySelector("input:checked + label h4.out_of_stock").innerText || null;
        preorder != null && formData.append("properties[Preorder]", preorder)
    } catch (e) {}
    formData.set("sections_url", window.location.pathname);
    if (cartDrawer) {
        formData.set("sections", cartDrawer.getSectionsToRender().map(function(section) {
            return section.id
        }).join(","));
        cartDrawer.setActiveElement(submitButton)
    }
    var params = {
        type: "POST",
        contentType: !1,
        processData: !1,
        url: "/cart/add.js",
        data: formData,
        dataType: "json",
        success: function(item) {
            
            var area = (final_width_cm - 6) * (final_height_cm - 6) / 1e4;
            if (area < 1) var cartValue = 5;
            else if (area > 50) var cartValue = 10;
            else var cartValue = 60;
            window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                page_type: "product",
                event: "addtocart",
                currency: Shopify.currency.active,
                totalValue: cartValue,
                productID: productID
            });
            submitButton.removeAttribute("aria-disabled");
            submitButton.querySelector("span").innerText = submitButtonText;
            if (cartDrawer && item.sections) {
                cartDrawer.renderContents(item)
            } else {
                window.location.href = cart_url
            }
        },
        error: function() {
            submitButton.removeAttribute("aria-disabled");
            submitButton.querySelector("span").innerText = submitButtonText;
            alert("We could not add this mural to your basket. Please try again.")
        }
    };
    $.ajax(params)
}

function createBlob(dataURL) {
    var BASE64_MARKER = ";base64,";
    if (dataURL.indexOf(BASE64_MARKER) == -1) {
        var parts = dataURL.split(","),
            contentType = parts[0].split(":")[1],
            raw = decodeURIComponent(parts[1]);
        return new Blob([raw], {
            type: contentType
        })
    }
    for (var parts = dataURL.split(BASE64_MARKER), contentType = parts[0].split(":")[1], raw = window.atob(parts[1]), rawLength = raw.length, uInt8Array = new Uint8Array(rawLength), i2 = 0; i2 < rawLength; ++i2) uInt8Array[i2] = raw.charCodeAt(i2);
    return new Blob([uInt8Array], {
        type: contentType
    })
}

function toggleID(id) {
    document.getElementById(id).classList.contains("hide") ? document.getElementById(id).classList.remove("hide") : document.getElementById(id).classList.add("hide")
}

function urlParams(tcm, lcm) {
    top_cm = tcm, left_cm = lcm, Uparams.delete("d"), Uparams.append("d", product_handle), Uparams.delete("w"), Uparams.append("w", final_width_cm - 6), Uparams.delete("h"), Uparams.append("h", final_height_cm - 6), Uparams.delete("t"), Uparams.append("t", top_cm), Uparams.delete("l"), Uparams.append("l", left_cm), Uparams.delete("m"), Uparams.append("m", monoX), Uparams.delete("f"), Uparams.append("f", flipX), typeof pattern_width == "number" && (Uparams.delete("p"), Uparams.append("p", pattern_width));
    try {
        pattern_width == "Pano" && (Uparams.delete("p"), Uparams.append("p", img.width / img.height * final_height_cm))
    } catch (e) {}
    Uparams.delete("u"), Uparams.append("u", user_width_units)
}

function material_change(el) {
    if (typeof el == "undefined" || el == null) {
        var el = document.querySelector("input.c-ptype__radio:checked");
        if (typeof el == "undefined" || el == null) {
            document.querySelector("span.drops").classList.add("hidden");
            return
        }
    }
    if (el.parentElement.querySelector("label").innerText.split("\n")[0].includes("Heavy")) var dropwidth = 50;
    else if (el.parentElement.querySelector("label").innerText.split("\n")[0].includes("Vinyl")) var dropwidth = 50;
    else var dropwidth = 50;
    var drop_q = Math.ceil(final_width_cm / dropwidth);
    if (user_height_units == "in" || user_height_units == "ft") var primary_measurement = Math.round(dropwidth / 2.54, 0) + "in",
        secondary_measurement = dropwidth + "cm",
        drop_height = Math.round((user_height * unit_conversion[user_height_units] + 6) / 2.54, 0) + "in";
    else var primary_measurement = dropwidth + "cm",
        secondary_measurement = Math.round(dropwidth / 2.54, 0) + "in",
        drop_height = Math.round(user_height * unit_conversion[user_height_units] + 6, 0) + "cm";
    if (el) {
        var materialSelector = document.querySelector('#mural-material-selector');
        if (materialSelector) {
            var materialOption = materialSelector.querySelector('option[data-variant-id="' + el.value + '"]');
            if (materialOption) materialSelector.value = materialOption.value;
        }
    }
    user_height + user_height_units, document.querySelector("span.drops").innerText = drop_text.replace("[P]", primary_measurement).replace("[S]", secondary_measurement).replace("[Q]", drop_q).replace("[H]", drop_height), document.querySelector("span.drops").innerText.includes("[") ? document.querySelector("span.drops").classList.add("hidden") : document.querySelector("span.drops").classList.remove("hidden");
    updatePrice()
}

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null
}

function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex
}
function clickmoreinfo(s) {
  window.location = s;
}
function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b)
}
